/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StandortInputs */

const de__field_standort = /** @type {(inputs: _Field_StandortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

/**

* @param {_Field_StandortInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_standort = /** @type {((inputs?: _Field_StandortInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StandortInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_standort(inputs)
});